/**
 * 模块名称：
 * @author ：XXXXX
 */
import { Toast } from 'vant';
import wxapi from '@/utils/wxapi.js';
import { agentJob, agentSour } from '@/api/agentOperation'
const state = {
    count: 5,
    dataList: [],
    sumData: {
        resume_received_num: 0, //收到简历数【总和】
        pass_screen_num: 0, //通过初筛【总和】
        interview_num: 0, //面试中【总和】
        augent_finish_num: 0, //代运营完成【总和】
    },
    confCount: 10,
    jobListData: [

    ],
    tabIndex: 7,
    isFirst: false
}

const mutations = {
    /**
     * 为state项赋值
     * @param state
     * @param data
     */
    setStateItem(state, data) {
        state[data.key] = data.value
    },

}

const actions = {

    /* 
        待确认职位列表
    */
    async requestAgentJob({ state, commit }, data) {
        try {
            const res = await agentJob(data)
            if (res.data.code == 200) {
                data.cb && data.cb();
                commit('setStateItem', { key: 'jobListData', value: res.data.data.list })
                commit('setStateItem', { key: 'confCount', value: res.data.data.count })
                commit('setStateItem', { key: 'isFirst', value: true })
                let parames = {
                    title: '上禾蛙hewa.cn，更多职位等你来',
                    dec: '猎头上禾蛙—简历不浪费，职位不白费'
                }
                wxapi(parames)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /* 
        待确认确认合同
     */
    async requestAgentSour({ state, commit }, data) {
        try {
            const res = await agentSour(data)
            if (res.data.code == 200) {
                data.cb && data.cb();
                let parames = {
                    title: '上禾蛙hewa.cn，更多职位等你来',
                    dec: '猎头上禾蛙—简历不浪费，职位不白费'
                }
                wxapi(parames)
                return false
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
}

export default {
    state,
    actions,
    mutations,
    namespaced: true,
}
